import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { ConfigurationService } from '../shell/services/configuration.service';
import { map } from 'rxjs/internal/operators/map';
import { Observable, catchError, forkJoin } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    constructor(
        private logger: LoggerService,
        private http: HttpClient,
        private configService: ConfigurationService,
    ) { }

    getReferenceData() {
        const referenceDataApiUrl = this.configService.getConfig()?.shell.api.referenceDataApiUrl;

        this.logger.info('getReferenceData > url: ' + referenceDataApiUrl);
        return this.http.get(referenceDataApiUrl + 'data/all').pipe(
            map(
                (response: any) => {
                    if (response) {
                        return response;
                    }
                    this.logger.info('getReferenceData > no data returned');
                    return null;
                }
            ),
            catchError((err: any) => {
                this.logger.error("getReferenceData > error", err);
                return err;
            })
        );
    }

    getReferenceDataByName(referenceTypes: any, name: string) {
        let retval;

        if (referenceTypes) {
            referenceTypes.forEach((category: any) => {
                if (category.name === name) {
                    retval = category.values;
                }
            });
        }

        return retval;
    }

    //From crm it's possible to set a nationality which isnt in the shortlist
    // This should be prevented by staff training but it could still happen.
    //if it does happen and then it is round tripped to the portal it is likely to result in data loss
    //so we add the applicants nationality to the list to preserve data.
    ensureNationalityIsInShortList(refData: any, nationalityId: string) {

        //if the applicants nationality is already n the shortlist then nothing to do.
        const shortlist: any = this.getReferenceDataByName(refData, "vw_nationalitytype_shortlist");
        const shortMatch: any = shortlist.filter((item: any) => item.value === nationalityId);
        if (shortMatch.length > 0) {
            console.log('NATIONALITY ALREADY IN SHORTLIST')
            console.log(shortlist);
            return;
        }

        // Otherwise, if the nationality is in the full list, add it to the top of the short list.
        const fullList: any = this.getReferenceDataByName(refData, "cn_nationalitytype")
        console.log(fullList);

        const fullMatch: any = fullList.filter((item: any) => item.value === nationalityId);
        if (fullMatch.length === 1) {
            console.log('NATIONALITY ADDED TO SHORTLIST FROM FULL LIST')

            shortlist.unshift(fullMatch[ 0 ]);
            console.log(shortlist);

        }
    }

    getDictionaryItems() {
        const dictionaryApiUrl = 'https://' + window.location.host;
        const url = dictionaryApiUrl + "/umbraco/api/dictionary/get/";
        return this.http.get<any>(url);
    }

    getDictionaryItemByKeyAndLanguage(dictionaryItems: any, key: string, langaugeCode: string) {
        let retval;

        if (dictionaryItems) {
            dictionaryItems.forEach((value: any) => {
                if (value.key === key) {
                    value.values.forEach((translation: any) => {
                        if (translation.code === langaugeCode) {
                            retval = translation.value;
                        }
                    })
                }

            })

        }

        return retval;
    }

    getAddressesForPostcode(postCode: string) {
        const postCodeApiUrl = this.configService.getConfig()?.shell.api.postCodeApiUrl;

        return this.http.get(`${postCodeApiUrl}postcodes?postcode=${postCode}`)
            .pipe(
                catchError(error => {
                    throw 'Error in delaying profile review: ' + error;
                })
            );
    }

    ready(nextObservables: Observable<any>[]) {
        return forkJoin(nextObservables);
    }
}
